import axios from 'axios';
import { RequestParams, RequestResponse } from '@/src/features/api/requester/interfaces';
import { onRequestError } from '@/src/features/api/requester/errors';
import { ENV } from '../../../.env';

export class Requester {
  static get<TParams = undefined, TBody = undefined, TResult = void>(
    params: RequestParams<TParams, TBody>,
  ): RequestResponse<TResult> {
    const controller = new AbortController();
    const root = `${ENV.API_URL}/${params.path}`;
    const path = params.query ? `${root}?${params.query}` : root;
    const request = axios.get<TResult>(path, {
      params: params.params,
      headers: params.headers,
      signal: controller.signal,
      timeout: params.timeout ?? 60000,
      withCredentials: true,
    }).catch(onRequestError);

    return { abort: () => controller.abort(), request } as RequestResponse<TResult>;
  }

  static post<TParams = undefined, TBody = undefined, TResult = void>(
    params: RequestParams<TParams, TBody>,
  ): RequestResponse<TResult> {
    const controller = new AbortController();
    const request = axios.post<TResult>(`${ENV.API_URL}/${params.path}`, params.body, {
      params: params.params,
      headers: params.headers,
      signal: controller.signal,
      timeout: params.timeout ?? 60000,
      withCredentials: true,
    }).catch(onRequestError);

    return { abort: () => controller.abort(), request } as RequestResponse<TResult>;
  }

  static put<TParams = undefined, TBody = undefined, TResult = void>(
    params: RequestParams<TParams, TBody>,
  ): RequestResponse<TResult> {
    const controller = new AbortController();
    const request = axios.put<TResult>(`${ENV.API_URL}/${params.path}`, params.body, {
      params: params.params,
      headers: params.headers,
      signal: controller.signal,
      timeout: params.timeout ?? 60000,
      withCredentials: true,
    }).catch(onRequestError);

    return { abort: () => controller.abort(), request } as RequestResponse<TResult>;
  }
}
